import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconButton } from '../ensigns/icon-button';
import { SpecraStatusDot } from '../ensigns/status-dot';
import { SpecraText } from '../ensigns/typography';
const toneClass = {
    neutral: 'border-border bg-muted',
    success: 'border-success/20 bg-success-muted',
    warning: 'border-warning/20 bg-warning-muted',
    danger: 'border-danger/20 bg-danger-muted',
    info: 'border-info/20 bg-info-muted'
};
/**
 * Persistent contextual feedback with optional undo/action and dismissal.
 * The body is a block, so it may hold a list or several lines.
 */ export function SpecraInlineBanner({ action, children, className, dismissLabel = 'Dismiss notification', onDismiss, title, tone = 'neutral', variant = 'band', ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex gap-2.5 px-4 py-2.5', title ? 'items-start' : 'items-center', variant === 'framed' ? 'rounded-[var(--radius-md)] border' : 'border-b', toneClass[tone], className),
        "data-variant": variant,
        role: tone === 'danger' ? 'alert' : 'status',
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraStatusDot, {
                className: title ? 'mt-[var(--space-1)]' : undefined,
                tone: tone
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "div",
                className: "min-w-0 flex-1",
                size: "caption",
                tone: "secondary",
                children: [
                    title ? /*#__PURE__*/ _jsx("div", {
                        className: "font-medium text-foreground",
                        children: title
                    }) : null,
                    title && children ? /*#__PURE__*/ _jsx("div", {
                        className: "mt-[var(--space-0-5)]",
                        children: children
                    }) : children
                ]
            }),
            action,
            onDismiss ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                label: dismissLabel,
                onClick: onDismiss,
                size: "sm",
                variant: "ghost",
                children: "×"
            }) : null
        ]
    });
}
